import { RadioGroup } from 'design-components';
import React from 'react';
import { UserPermissionRole } from 'utilities/enum-utils';
import { ADVANCED_PERMISSION_ROLE_TYPE } from 'views/team-v2/utils/constants';
import ActionSelectedItem from '../ActionSelectedItem';
import AdvancedPermissionRow from '../AdvancedPermissionRow';

interface IProps {
  permissionRoleId: number;
  changePermissionForEachRole?: (value: number, permissionKey: string) => void;
  typePermissionPresent: string;
  handleSetTypePermissionPresent: (value: string) => void;
}

const PermissionSubscriptionSection: React.FC<IProps> = ({
  permissionRoleId = UserPermissionRole.NoAccess,
  changePermissionForEachRole,
  typePermissionPresent,
  handleSetTypePermissionPresent,
}) => {
  return (
    <AdvancedPermissionRow
      title="Subscription billing & access"
      description="GoodHuman subscription"
      permissionRoleId={permissionRoleId}
      type={ADVANCED_PERMISSION_ROLE_TYPE.SUBSCRIPTION}
      typePermissionPresent={typePermissionPresent}
      handleSetTypePermissionPresent={handleSetTypePermissionPresent}
      extendPermissions={
        <RadioGroup
          aria-label="subscription"
          value={permissionRoleId}
          onChange={(value) => changePermissionForEachRole(value, 'subscription')}
        >
          <ActionSelectedItem
            ariaLabel="subscription-no-access"
            label="No access, cannot view or access this section"
            value={UserPermissionRole.NoAccess}
            selectedPermission={permissionRoleId}
          />
          <ActionSelectedItem
            ariaLabel="subscription-view-only"
            label="View-only access, can view but not perform any actions within this section"
            value={UserPermissionRole.SubscriptionBillingViewOnly}
            selectedPermission={permissionRoleId}
          />
          <ActionSelectedItem
            ariaLabel="subscription-all-access"
            label="All access, can see and perform key actions within this section"
            value={UserPermissionRole.SubscriptionBillingAllAccess}
            selectedPermission={permissionRoleId}
          />
        </RadioGroup>
      }
    />
  );
};

export default PermissionSubscriptionSection;
